// A chat voice clip's address, playable. Until 17 October 2026 the backend linked every clip to
// storage.promptdrive.com, a domain that is not ours (its TLS refuses the name), though the file sits in our bucket at
// storage.promptdrive.net; the clips saved in chats keep the old address, so it is mended here when one is played.
const WRONG_HOST = 'https://storage.promptdrive.com/'
const OUR_HOST = 'https://storage.promptdrive.net/'

export function playableAudioUrl(url) {
  return typeof url === 'string' && url.startsWith(WRONG_HOST)
    ? OUR_HOST + url.slice(WRONG_HOST.length)
    : url
}
